import { CSSProperties, useLayoutEffect, useRef, useState } from "react";
import { decodeSiteResolutionValue, useSiteResolution } from "shared/mechanics/site-resolution";

export interface D3PortalProps {
	generateSvg: (size: D3PortalPropsChartSize) => SVGSVGElement;
}

export interface D3PortalPropsChartSize {
	width: number;
	height: number;
}

export const D3Portal = (props: D3PortalProps) => {
	const [chartSize, setChartSize] = useState<D3PortalPropsChartSize | null>({ width: 0, height: 0 });
	const chartContainerRef = useRef<HTMLDivElement>(null);

	const siteResolution = useSiteResolution();
	const portalStyle = decodeSiteResolutionValue<CSSProperties>(
		siteResolution,
		{ width: '100%', height: '100%' },
		{ width: '100%', height: '790px' });

	useLayoutEffect(() => {
		if (chartContainerRef.current === null)
			return;

		setChartSize({ width: chartContainerRef.current.offsetWidth, height: chartContainerRef.current.offsetHeight });

		if (ResizeObserver)
		{
			var resizeObserver = new ResizeObserver(() => {
				if (chartContainerRef.current == null)
					return;

					setChartSize({ width: chartContainerRef.current.offsetWidth, height: chartContainerRef.current.offsetHeight });
			});

			resizeObserver.observe(chartContainerRef.current);

			return () => {
				resizeObserver.disconnect();
			}
		}
	}, [chartContainerRef.current]);

	useLayoutEffect(() => {
		if (chartSize === null)
			return;
		if (chartContainerRef.current === null)
			return;

		const newSvg = props.generateSvg(chartSize);

		chartContainerRef.current.innerHTML = '';
		chartContainerRef.current.append(newSvg);
	}, [chartSize, chartContainerRef.current, props.generateSvg]);

	return <div style={portalStyle} ref={chartContainerRef}></div>;
}